const generateOrbitHostname = () => {
  const hostName = window.location.hostname
  switch (hostName) {
    case 'dsg-orbit.circleslife.co':
      return 'https://ssg-orbit-api.circleslife.co'
    case 'orbit.circleslife.co':
      return 'https://ssg-orbit-api.circleslife.co'
    case 'orbit.circles.life':
      return 'https://orbit-api.circles.life'
    default:
      return 'http://localhost:3000'
  }
}

/* TODO: deprecate the following function, react should not have evaluate env
const generateOrbitHostname_OLD = () => {
  let hostname

  switch (process.env.NODE_ENV) {
    // if built to be deployed, it will get the api server based on where this repo is
    case 'production':
      if (process.env.REACT_APP_DEPLOY_ENV === 'staging') {
        hostname = process.env.REACT_APP_STAGING_BACKEND
      } else if (process.env.REACT_APP_DEPLOY_ENV === 'preprod') {
        hostname = process.env.REACT_APP_PREPROD_BACKEND
      } else {
        hostname = process.env.REACT_APP_PROD_BACKEND
      }
      break

    // if in development mode, we can conditionally switch backends to test
    case 'development':
      if (process.env.REACT_APP_DEV_ENV === 'staging') {
        hostname = process.env.REACT_APP_STAGING_BACKEND
      } else {
        // hostname = process.env.REACT_APP_DEV_BACKEND
        hostname = process.env.REACT_APP_STAGING_BACKEND
      }
      break

    default:
      break
  }

  return hostname
}
*/

export default generateOrbitHostname
